/**
 * Ürün maliyet / has hesapları.
 *
 * Öncelik:
 * - iscilik > 0        → gram × (milyem + iscilik) × kur   (mevcut işçilik, grama bağlı)
 * - adetIscilik > 0    → ((gram × milyem) + adetIscilik) × kur  (adet sabit)
 * - ikisi de boş/0     → gram × milyem × kur
 *
 * Eski ürünlerde adetIscilik yoksa / 0 ise davranış: yalnızca iscilik yolu.
 */

function toNum(value) {
  if (value == null || value === '') return 0;
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  const normalized = String(value).trim().replace(/\s/g, '').replace(',', '.');
  const n = parseFloat(normalized);
  return Number.isFinite(n) ? n : 0;
}

export function getUrunIscilik(product) {
  return toNum(product?.iscilik);
}

export function getUrunAdetIscilik(product) {
  return toNum(product?.adetIscilik);
}

/** İşçilik > 0 ise normal işçilik modu */
export function usesIscilikLabor(product) {
  return getUrunIscilik(product) > 0;
}

/** İşçilik boş/0 ve adet işçiliği > 0 ise adet modu */
export function usesAdetIscilikLabor(product) {
  return !usesIscilikLabor(product) && getUrunAdetIscilik(product) > 0;
}

/** @returns {'iscilik' | 'adetIscilik' | null} */
export function getUrunLaborType(product) {
  if (usesIscilikLabor(product)) return 'iscilik';
  if (usesAdetIscilikLabor(product)) return 'adetIscilik';
  return null;
}

/**
 * Has cinsinden ürün maliyeti (kur çarpılmadan).
 */
export function calculateUrunMaliyetHas(product) {
  const gram = toNum(product?.gram);
  const milyem = toNum(product?.urunMilyem ?? product?.milyem);
  const iscilik = getUrunIscilik(product);
  const adetIscilik = getUrunAdetIscilik(product);

  if (iscilik > 0) {
    return gram * (milyem + iscilik);
  }
  if (adetIscilik > 0) {
    return gram * milyem + adetIscilik;
  }
  return gram * milyem;
}

/**
 * TL maliyet = has × has kuru.
 */
export function calculateUrunMaliyetTry(product, hasKuru) {
  const kur = toNum(hasKuru ?? product?.hasAltinKuru);
  return calculateUrunMaliyetHas(product) * kur;
}

/**
 * İşçilik / adet işçiliği tutarı (TL). Has altın değeri hariç.
 * - iscilik: gram × iscilik × kur
 * - adetIscilik: adetIscilik × kur
 */
export function calculateUrunLaborTry(product, hasKuru) {
  const gram = toNum(product?.gram);
  const kur = toNum(hasKuru ?? product?.hasAltinKuru);
  if (!(kur > 0)) return 0;
  if (usesIscilikLabor(product)) {
    return gram * getUrunIscilik(product) * kur;
  }
  if (usesAdetIscilikLabor(product)) {
    return getUrunAdetIscilik(product) * kur;
  }
  return 0;
}

/** Firestore / form için boşsa null */
export function normalizeAdetIscilikForSave(value) {
  const n = toNum(value);
  return n > 0 ? n : null;
}

export function normalizeIscilikForSave(value) {
  const n = toNum(value);
  return n > 0 ? n : null;
}
